import { render, staticRenderFns } from "./CertificationHistory.vue?vue&type=template&id=ad7ec6a0&"
import script from "./CertificationHistory.vue?vue&type=script&lang=js&"
export * from "./CertificationHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports